jQuery(function($) {
	// Function to update links based on language
	function updateLinks() {
		// Check if links already exist and need updating
		if ($('.cky-preference-center a').length === 0 && $('.cky-notice-des a').length === 0) {
			return false; // No links to update yet
		}

		// Get language once
		const lang = document.documentElement.lang;

		if (lang === 'en-gb') {
			// 'Cookie Notice' link for en-gb
			$('.cky-preference-center a:first, .cky-notice-des a:first').text('Cookie Notice').attr('href', 'https://www.ebay.co.uk/help/policies/member-behaviour-policies/ebay-cookie-notice?id=4267');
			// 'Third-party companies' link for en-gb
			$('.cky-preference-center a:eq(1), .cky-notice-des a:eq(1)').text('third-party companies').attr('href', 'https://www.ebay.co.uk/gdpr?vendorlist=true');
			// 'GPDR' link for en-gb
			$('.cky-preference-center a:eq(2), .cky-notice-des a:eq(2)').text('https://www.ebay.co.uk/gdpr').attr('href', 'https://www.ebay.co.uk/gdpr');
		} else if (lang === 'en-au') {
			// 'Cookie Notice' link for en-au
			$('.cky-preference-center a:first, .cky-notice-des a:first').text('Cookie Notice').attr('href', 'https://www.ebay.com.au/help/policies/member-behaviour-policies/ebay-cookie-notice?id=4267');
			// 'Third-party companies' link for en-au
			$('.cky-preference-center a:eq(1), .cky-notice-des a:eq(1)').text('third-party companies').attr('href', 'http://ebay.com.au/gdpr');
			// 'GPDR' link for
			$('.cky-preference-center a:eq(2), .cky-notice-des a:eq(2)').text('https://www.ebay.com.au/gdpr').attr('href', 'https://www.ebay.com.au/gdpr');
		}
		return true; // Links were updated
	}

	// Try to find the cookie notice container
	function findCookieContainer() {
		// Common cookie notice container selectors
		const possibleContainers = [
			'#cookie-law-info-bar',
			'#cookie-notice',
			'.cky-consent-container',
			'#cky-consent'
		];

		// Find the first matching container
		for (let selector of possibleContainers) {
			const container = document.querySelector(selector);
			if (container) {
				return container;
			}
		}

		return document.body; // Fallback to body if no specific container found
	}

	// Flag to track if we've already set up the click handler
	let clickHandlerSet = false;

	// Function to set up click handler (only once)
	function setupClickHandler() {
		if (clickHandlerSet) return;

		$(document).on('click', '.cky-show-desc-btn, .cky-btn-accept, .cky-btn-reject, .cky-btn-customize', function() {
			// Small delay to allow DOM to update
			setTimeout(updateLinks, 50);
		});

		clickHandlerSet = true;
	}

	// Initial attempt to update links
	if (updateLinks()) {
		// If links were updated successfully on page load, set up click handler
		setupClickHandler();
	} else {
		// Find the most specific container to observe
		const containerToObserve = findCookieContainer();

		// Create a more targeted observer
		const observer = new MutationObserver(function(mutations) {
			// Check if any of the mutations added the elements we're looking for
			let shouldUpdate = false;

			for (let mutation of mutations) {
				if (mutation.type === 'childList' && mutation.addedNodes.length) {
					// Check if any added nodes contain our target elements
					for (let node of mutation.addedNodes) {
						if (node.nodeType === 1) { // Element node
							if (node.querySelector('.cky-preference-center a, .cky-notice-des a')) {
								shouldUpdate = true;
								break;
							}
						}
					}
					if (shouldUpdate) break;
				}
			}

			if (shouldUpdate && updateLinks()) {
				// If links were updated successfully, set up click handler
				setupClickHandler();

				// Disconnect observer after successful update to save resources
				observer.disconnect();
			}
		});

		// Start observing with more specific options
		observer.observe(containerToObserve, {
			childList: true,
			subtree: true,
			attributes: false,
			characterData: false
		});

		// Set a timeout to disconnect the observer after a reasonable time
		// to prevent it from running indefinitely
		setTimeout(function() {
			if (observer) {
				observer.disconnect();
			}
		}, 10000); // 10 seconds
	}
});
